import { Injectable } from '@angular/core';
import { StorageService } from '../storage/storage.service';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environments';
import { HttpClient } from '@angular/common/http';
import { StorageKeys } from '../../shared/enums/storage.enum';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private userSubject = new BehaviorSubject<any>(null);
  user$ = this.userSubject.asObservable();
  private readonly creditsSubject = new BehaviorSubject<number>(0);
  credits$ = this.creditsSubject.asObservable();

  private refreshCredits$ = new BehaviorSubject<void>(undefined);
  creditsRefresh$ = this.refreshCredits$.asObservable();

  constructor(
    private storageService: StorageService,
    private router: Router,
    private readonly http: HttpClient,
  ) {
    const stored = this.storageService.getDataFromLocalStorage(StorageKeys.SELF_DETAILS);
    if (stored) {
      this.userSubject.next(stored);
    }
    this.creditsRefresh$.subscribe(() => {
      this.fetchCredits().subscribe({
        error: (err) => console.error('Failed to auto-refresh credits:', err)
      });
    });
  }

  setUser(user: any) {
    this.userSubject.next(user);
    if (user) {
      this.triggerCreditsRefresh();
    } else {
      this.setCredits(0);
    }
  }

  setCredits(value: number): void {
    this.creditsSubject.next(value);
  }

  triggerCreditsRefresh() {
    this.refreshCredits$.next();
  }

  fetchCredits(): Observable<number> {
    const token = this.storageService.getDataFromLocalStorage(StorageKeys.ACCESS_TOKEN);
    if (!token) {
      return of(this.creditsSubject.value);
    }
    const url = `${environment.API_URL}/v1/user-credit`;
    return this.http.get(url).pipe(
      map((res: any) => {
        const value = res?.data?.credits ?? res?.data?.esignCredits ?? res?.credits ?? 0;
        this.setCredits(value);
        return value;
      })
    );
  }

  getSelfDetails(): Observable<any> {
    const url = `${environment.API_URL}/v1/auth/self`;
    return this.http.get(url);
  }

  logout(): Observable<any> {
    const url = `${environment.API_URL}/v1/auth/logout`;
    return this.http.get(url);
  }
}

